module.exports = __webpack_public_path__ + "fonts/庞门正道标题体.26875b76.ttf";